var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFormats(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.45459 5.90894V6.72712C3.45459 8.53448 4.91995 9.99984 6.72732 9.99984H13.2728C15.0801 9.99984 16.5455 8.53448 16.5455 6.72712V5.90894",
    stroke: "#7F8585",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.99988V14.0908",
    stroke: "#7F8585",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.45455 5.90897C4.81015 5.90897 5.90909 4.81003 5.90909 3.45442C5.90909 2.09882 4.81015 0.999878 3.45455 0.999878C2.09894 0.999878 1 2.09882 1 3.45442C1 4.81003 2.09894 5.90897 3.45455 5.90897Z",
    stroke: "#7F8585",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 18.9999C11.3556 18.9999 12.4545 17.901 12.4545 16.5454C12.4545 15.1898 11.3556 14.0908 9.99996 14.0908C8.64435 14.0908 7.54541 15.1898 7.54541 16.5454C7.54541 17.901 8.64435 18.9999 9.99996 18.9999Z",
    stroke: "#7F8585",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5454 5.90885C17.901 5.90885 18.9999 4.80991 18.9999 3.4543C18.9999 2.09869 17.901 0.999756 16.5454 0.999756C15.1898 0.999756 14.0908 2.09869 14.0908 3.4543C14.0908 4.80991 15.1898 5.90885 16.5454 5.90885Z",
    stroke: "#7F8585",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormats);
export default __webpack_public_path__ + "static/media/formats.bdc18ead28abc5fb39b5ddfaf4ac2599.svg";
export { ForwardRef as ReactComponent };